import axios from "axios";
import { supabase } from "../supabaseClient";
import { getBackend } from "../utils/getBackend";
import { getAccessTokenHeader } from "./helper/getAccessTokenHeader";

interface HashtagRequest {
  imageUrls: string[];
  maxHashtags?: number;
  model?: string;
  temperature?: number;
  thread_id?: string;
  previous_response_id?: string;
  previous_hashtags?: string[];
}

interface HashtagResponse {
  id: string;
  prompt: string;
  hashtags: string[];
  created_at: string;
  model: string;
  usage: any;
  thread_id?: string;
}

export async function handleGenerateHashtags({
  imageUrls,
  maxHashtags = 10,
  model = "gpt-4o-mini",
  temperature = 0.7,
  thread_id,
  previous_response_id,
  previous_hashtags,
}: HashtagRequest): Promise<HashtagResponse> {
  try {
    const {
      data: { session },
      error: sessionError,
    } = await supabase.auth.getSession();

    if (sessionError || !session) {
      throw new Error("Not authenticated");
    }

    const response = await axios.post(
      getBackend() + "/ai/prompts/hashtags",
      {
        imageUrls,
        maxHashtags,
        model,
        temperature,
        thread_id,
        previous_response_id,
        previous_hashtags,
      },
      {
        headers: await getAccessTokenHeader(),
      }
    );

    if (response.status !== 200) {
      const error = response.data;
      throw new Error(error.error || "Failed to generate hashtags");
    }

    return response.data;
  } catch (error) {
    console.error("Error generating hashtags:", error);
    throw error;
  }
}
